const blogData = [
    {
        id:"1",
        image:require("../../assets/image/1 (1).webp"),
        title:"Real Estate Investment",
        fullTitle:"Real Estate Investment: Your Path to Financial Freedom",
        details:"We help you achieve your financial goals through smart real estate investment. Our platform offers the latest carefully selected real estate opportunities in top locations, enabling you to make well-informed investment decisions based on accurate data and advanced analysis. We believe that real estate is one of the most powerful investment assets, and we are committed to providing you with the tools and information needed to maximize your returns.",
    },
    {
        id:"2",
        image:require("../../assets/image/1 (2).webp"),
        title:"Why Buying Property in the UAE is Your Best Investment?",
        fullTitle:"Why Buying Property in the UAE is Your Best Investment?",
        details:"The UAE offers an ideal investment environment that combines economic stability, high returns, and attractive tax exemptions. Whether you are looking for a luxury home or a property that generates passive income, the UAE provides unparalleled investment opportunities. Discover how you can benefit from the UAE real estate market and achieve outstanding returns on your investments.",
    },
    {
        id:"3",
        image:require("../../assets/image/1 (3).webp"),
        title:"How to Choose the Perfect Property?",
        fullTitle:"How to Choose the Perfect Property?",
        details:"Buying a property is one of the most important financial decisions you will ever make, but how do you choose the perfect one? In this guide, we will walk you through the key factors to consider when purchasing a property, from location and design to expected investment returns. Discover with us the secrets that will make you a successful real estate investor.",
    },
]

export default blogData;